<template>
  <div class="main">
    <base-card v-for="sandwich in sandwiches" :key="sandwich.name">
      <v-card-title>{{ sandwich.name }}</v-card-title>
      <v-card-text>{{ sandwich.text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        {{ sandwich.price }}
      </v-card-actions>
    </base-card>
    <base-card color="#DC143C">
      <v-card-title class="flex text-center">Ладни Сендвичи</v-card-title>
    </base-card>
    <base-card v-for="sub in subs" :key="sub.name">
      <v-card-title>{{ sub.name }}</v-card-title>
      <v-card-text>{{ sub.text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        {{ sub.price }}
      </v-card-actions>
    </base-card>
    <base-card color="#DC143C">
      <v-card-title class="flex text-center">Помфрити</v-card-title>
    </base-card>
    <base-card>
      <v-card-title>Помфрит</v-card-title>
      <v-card-actions class="flex text-right">
        <v-spacer></v-spacer>
        Мал 60 ден. <br />
        Голем 80 ден.
      </v-card-actions>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sandwiches: [
        {
          name: "Лепче со плескавица",
          text: "Лепиња, плескавица, салата",
          price: "130 ден.",
        },
        {
          name: "Хамбургер",
          text: "Лепиња, плескавица, помфрит, салата",
          price: "160 ден.",
        },
        {
          name: "Чизбургер",
          text: "Лепиња, плескавица, кашкавал, помфрит, салата",
          price: "190 ден.",
        },
        {
          name: "Сиви",
          text: "Лепче, помфрит, салата",
          price: "120 ден."
        },
        {
          name: "Лепче со пилешки стек",
          text: "Лепиња, пилешки стек, салата",
          price: "150 ден.",
        },
        {
          name: "Чикен бургер",
          text: "Лепиња, пилешки стек, помфрит, салата",
          price: "180 ден.",
        },
        {
          name: "Криспи Чикен",
          text: "Лепиња, похован пилешки стек, помфрит, салата",
          price: "200 ден.",
        },
        {
          name: "ЕКСТРА ЧИКЕН",
          text: "Лепиња, пилешки стек, кашкавал, помфрит, салата",
          price: "210 ден.",
        },
        {
          name: "Француски",
          text: "Француска лепиња, пилешка салама, млечен кашкавал, помфрит, салата",
          price: "150 ден.",
        },
        {
          name: "Комбиниран",
          text: "Лепиња, пилешка шунка, млечен кашкавал, помфрит, салата",
          price: "160 ден.",
        },
        {
          name: "Вегетеријански",
          text: "Лепиња, кашкавал, печурки, помфрит, салата",
          price: "150 ден.",
        },
        {
          name: "Хот дог со 1 виршла",
          text: "Лепче, една виршла, сенф",
          price: "80 ден.",
        },
        {
          name: "Хот дог со 2 виршли",
          text: "Лепче, две виршли, сенф",
          price: "100 ден.",
        },
        {
          name: "Вуди хот дог 1",
          text: "Лепче, една виршла „Вуди“, сенф",
          price: "110 ден.",
        },
        {
          name: "Вуди хот дог 2",
          text: "Лепче, две виршли „Вуди“, сенф",
          price: "140 ден.",
        },
        {
          name: "Вуди хот дог 1 со помфрит",
          text: "Лепче, една виршла „Вуди“, помфрит, сенф",
          price: "150 ден.",
        },
        {
          name: "Вуди хот дог 2 со помфрит",
          text: "Лепче, две виршли „Вуди“, помфрит, сенф",
          price: "180 ден.",
        },
        {
          name: "Сендвич со 1 виршла",
          text: "Лепиња, една пилешка виршла, сенф, помфрит, салата",
          price: "120 ден.",
        },
        {
          name: "Сендвич со 2 виршли",
          text: "Лепиња, две пилешки виршли, сенф, помфрит, салата",
          price: "140 ден.",
        },
      ],
      subs: [
        {
          name: "Ладен со пилешка крем салата",
          text: "Лепиња, пилешка салата, павлака, марула",
          price: "100 ден.",
        },
        {
          name: "Ладен Чикен",
          text: " Лепиња, пилешка шунка, кашкавал, салата",
          price: "110 ден.",
        },
        {
          name: "Ладен Сендвич со кулен",
          text: " Лепиња, кулен, кашкавал, салата",
          price: "130 ден.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.main {
  min-height: 300vh;
  background: transparent;
}
</style>
